<template>
  <v-app>
    <v-main class="login-container">
      <v-container fluid fill-height>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="pa-5" elevation="10" rounded="xl">
              <v-card-title class="justify-center">
                <v-img src="@/assets/logoY.png" max-width="250" class="mb-2"></v-img>
              </v-card-title>

              <v-card-subtitle class="text-center mb-4">
                <h2 class="font-weight-bold">Portal Empresarial</h2>
              </v-card-subtitle>

              <v-card-text>
                <v-alert
                  v-if="alert"
                  :type="alertType"
                  dismissible
                  @click="alert = false"
                  class="mb-4"
                >
                  {{ alertText }}
                </v-alert>

                <v-form @submit.prevent="login">
                  <v-text-field
                    v-model="usuario"
                    label="Usuario"
                    prepend-inner-icon="mdi-account"
                    outlined
                    dense
                    required
                  />

                  <v-text-field
                    v-model="password"
                    label="Contraseña"
                    prepend-inner-icon="mdi-lock"
                    :type="showPassword ? 'text' : 'password'"
                    outlined
                    dense
                    required
                  >
                    <template v-slot:append-inner>
                      <v-icon @click="showPassword = !showPassword">
                        {{ showPassword ? 'mdi-eye-off' : 'mdi-eye' }}
                      </v-icon>
                    </template>
                  </v-text-field>

                  <v-btn color="primary" class="mt-4" block large type="submit">
                    Iniciar sesión
                  </v-btn>
                </v-form>
              </v-card-text>

              <v-card-actions class="justify-center">
                <small class="text-grey">
                  © {{ new Date().getFullYear() }} - DISTRIBUIDORA DE ABARROTES LA Y GRIEGA S.A. de C.V.
                </small>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-overlay :value="cargando" opacity="0.95">
        <div class="text-center">
          <v-img src="@/assets/logoY.png" max-width="100" class="mb-6 animate-logo"></v-img>
          <v-progress-circular indeterminate size="60" color="white"></v-progress-circular>
          <p class="mt-4 white--text">Cargando...</p>
        </div>
      </v-overlay>
    </v-main>
  </v-app>
</template>

<script>
import authService from '@/api/authService'

export default {
  name: 'Login',

  data() {
    return {
      usuario: '',
      password: '',
      showPassword: false,
      cargando: false,
      alert: false,
      alertText: '',
      alertType: 'error'
    }
  },

  created() {
    const msg = localStorage.getItem('loginMessage')

    if (msg) {
      this.alertText = msg
      this.alertType = 'warning'
      this.alert = true
      localStorage.removeItem('loginMessage')
    }
  },

  methods: {
    getRouteByRole(tipo) {
      switch (tipo) {
        case 'Proveedor':
          return '/home/proveedor'
        case 'Inventario':
          return '/home/inventario'
        case 'Cajero':
          return '/home/cajero'
        case 'Direccion':
          return '/home/direccion'
        case 'Sistemas':
          return '/home/sistemas'
        case 'Almacen':
          return '/home/almacen'
        default:
          return '/home'
      }
    },

    async login() {
      if (!this.usuario || !this.password) {
        this.alertText = 'Por favor ingrese usuario y contraseña'
        this.alertType = 'warning'
        this.alert = true
        return
      }

      this.cargando = true

      try {
        const { data } = await authService.login(this.usuario, this.password)

        if (data.error) {
          this.cargando = false
          this.alertText = data.msg
          this.alertType = 'error'
          this.alert = true
          return
        }

        const user = data.user || data.item

        if (!user || !user.usuario) {
          this.cargando = false
          this.alertText = 'El servidor no regresó los datos del usuario.'
          this.alertType = 'error'
          this.alert = true
          return
        }

        localStorage.setItem('token', data.token)
        localStorage.setItem('usuario', JSON.stringify(user))
        localStorage.setItem('usuarioClave', user.usuario)

        const destino = this.getRouteByRole(user.tipo)

        setTimeout(() => {
          this.cargando = false
          this.$router.push(destino)
        }, 1500)
        } catch (error) {
  console.error('Error en la conexión:', error)

  if (error.response) {

    this.alertText = 'Error del servidor. Revisa consola: DATA PHP.'
  } else {
    this.alertText = 'Error al conectar con el servidor.'
  }

  this.alertType = 'error'
  this.alert = true
  this.cargando = false
}
    }
  }
  
}
</script>

<style scoped>
.login-container {
  background: linear-gradient(135deg, #1976d2, #42a5f5);
  color: white;
}

.v-card {
  background: #fff;
}

@keyframes pulse {
  0% { transform: scale(1); opacity: 0.7; }
  50% { transform: scale(1.1); opacity: 1; }
  100% { transform: scale(1); opacity: 0.7; }
}

.animate-logo {
  animation: pulse 1.5s infinite;
}
</style>